import {
  type AxiosError,
  type AxiosInstance,
  type InternalAxiosRequestConfig,
  type AxiosResponse,
} from "axios";
import axios from "axios";
export const baseURL = process.env.REACT_APP_API_BASE_URL as string;
export * from "./request";

const axiosInstance: any = axios.create({
  baseURL,
  headers: {
    Accept: "application/json, text/plain, */*",
    // "Content-Type": "application/json, multipart/form-data",
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

const onRequest = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  return config;
};

const onRequestError = async (error: AxiosError): Promise<AxiosError> => {
  return await Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};

const onResponseError = async (error: AxiosError): Promise<AxiosError> => {
  if (error.response && error.response.status === 401) {
    localStorage.clear();
    window.location.reload();
  }

  return await Promise.reject(error);
};

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}

const specificAxios = setupInterceptorsTo(axiosInstance);

export default specificAxios;
